import { Radio as AntdRadio } from "antd";
import type { RadioGroupProps, RadioProps } from "antd";

const Radio = (props: RadioProps) => {
  return <AntdRadio {...props} />;
};

const Group = (props: RadioGroupProps) => {
  return <AntdRadio.Group {...props} />;
};

Radio.Group = Group;

export { Radio };
